import {
    Autocomplete,
    AutocompleteRenderInputParams,
    ListItemAvatar,
    ListItemText,
    Stack,
    TextField,
    TextFieldProps,
} from "@mui/material";
import React, {useCallback} from "react";
import {HibobOffice} from "../../api/Model";
import {useHibobOfficeStore} from "../../api/HibobOfficeStore";
import {idEqFn, idFn} from "../../util/FunctionUtil";
import {useRemoteValue} from "../../util/RemoteValue";
import {SiteChip} from "../site-chip/SiteChip";

const optionLabel = (office: HibobOffice) => office.badge || office.name;
const renderOption = ({key, ...props}: React.HTMLAttributes<HTMLLIElement> & { key: any }, office: HibobOffice) => (
    <Stack key={key} component="li" direction="row" spacing={2} justifyItems="stretch" {...props}>
        <ListItemText primary={office.name} slotProps={{primary: {sx: {textWrap: 'nowrap'}}}}/>
        {office.badge && (
            <ListItemAvatar>
                <SiteChip siteId={office.workSiteId} hibobOfficeId={office.id}/>
            </ListItemAvatar>
        )}
    </Stack>
);

export default function HibobOfficeSelect({value, onChange, ...props}: {
    value: HibobOffice | null,
    onChange: (office: HibobOffice | null) => void,
} & Omit<TextFieldProps, 'value' | 'onChange'>) {
    const options = useRemoteValue(useHibobOfficeStore(state => state.remoteValue), []);
    const renderInput = useCallback(
        (params: AutocompleteRenderInputParams) => <TextField {...params} {...props}/>,
        [props],
    );

    return (
        <Autocomplete<HibobOffice>
            fullWidth={props.fullWidth}
            options={options}
            value={value}
            onChange={(_, office) => onChange(office)}
            getOptionKey={idFn}
            getOptionLabel={optionLabel}
            isOptionEqualToValue={idEqFn}
            renderInput={renderInput}
            renderOption={renderOption}
            slotProps={{paper: {sx: {width: 'fit-content'}}}}
        />
    );
}
